//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const EmployeeFundsReportsConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/ewa/Reports",
      component: FuseLoadable({
        loader: () => import("./AdvanceReport.js")
      })
    }
  ]
  //end routes
};
